// 外部からアクセスでタブを開く ?id=tab1 など
document.addEventListener('DOMContentLoaded', function () {
  //URL取得とチェック
  var url = location.href;
  url = (url.match(/\?id=tab\d+$/) || [])[0];
  if (url) {
    //取得したURLを「?」で分割
    var params = url.split("?");

    //params内のデータを「=」で分割
    var tab = params[1].split("=tab");

    $('.download-sec__ins  li').removeClass('active');
    $('.download-sec__box').removeClass('active');
    var index = $('.download-sec__ins li').eq(tab[1]);
    index.addClass('active');
    $('.download-sec__box.box' + tab[1]).addClass('active');
  }
});

// タブクリック動作
$('.download-sec__ins li').on('click', function () {
  $('.download-sec__ins  li').removeClass('active');
  $('.download-sec__box').removeClass('active');

  var index = $('.download-sec__ins li').index(this);
  $(this).addClass('active');
  $('.download-sec__box.box' + index).addClass('active');
});


$(function() {
  $('.partners-sec__newsBox__list__item__topBox').on('click', function () {
    if ($(this).hasClass('open')) {
      $(this).next().slideUp();
      $(this).removeClass('open');
      $(this).children('.partners-sec__newsBox__list__item__btn').text('開く +');
    } else {
      $(this).next().slideDown();
      $(this).addClass('open');
      $(this).children('.partners-sec__newsBox__list__item__btn').text('閉じる -');
    }
  });
});
